<template>
  <div id="users-list-container" class="users-online p-0" :class="{'is-active': isUsersExpanded}">
    <div class="bg-gray-100">
      <div class="d-flex h-2">
        <a href="#" class="flex-none users-search pt-1 pl-2" v-show="isUsersExpanded" @click="toggleSearchForm">
          <i class="nav-icon fa fa-search text-small"></i>
        </a>
        <a href="#" class="users-toggle my-auto py-2" id="users-toggle">
          <small :class="isUsersExpanded ? 'less' : 'more'" @click="toggleUsers">
            {{ isUsersExpanded ? 'Less' : 'More' }}
          </small>
        </a>
      </div>
    </div>

    <li v-show="showSearchForm" id="search-user-menu" class="nav-item bg-gray-100 p-2" :class="{'showSearchDiv': showSearchForm}">
      <form-input v-model="searchValue" @input="searchUsersByName" placeholder="Find User" />
      <div v-if="showNotFoundMessage">
        <span class="text-truncate">Users not found</span>
      </div>
      <div v-else :class="{ 'd-block': searchResults.length > 0 }">
        <div
          v-for="user in searchResults"
          :key="user.id"
          :data-user-id="user.id"
          :class="getUserClasses(user)"
          @click="openChatConversation(user.id)"
        >
          <avatar :image="user.image" :alt="user.name" :status="user.status" />
          <span class="text-truncate font-weight-bold ml-2 pl-6">
            <strong>{{ user.name }}</strong>
            <br/>
            <small>{{user.branch}} | {{user.position}}</small>
          </span>
        </div>
      </div>
    </li>

    <div class="users-lists bg-white px-2" :class="{'d-block': !isUsersExpanded}">
      <users-list v-for="(list, index) in filteredUsersPresence" :key="index" :users="list.users" :status="list.status" :label="list.label" />
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations, mapGetters, mapActions } from "vuex";
import { getFloatingChatRooms, isFloating, openChatRoom, searchUsers } from "../../../services/api/uni-chat";
import UsersList from "./UsersList.vue";
import FormInput from "../../../components/form/Input.vue";
import Avatar from "../../../components/Avatar.vue";

export default {
  name: "UsersListContainer",
  components: {
    Avatar,
    UsersList,
    FormInput
  },
  props: {
    userLists: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      isLoading: false,
      isUsersExpanded: false,
      searchValue: '',
      searchResults: [],
      showSearchForm: false,
      showNotFoundMessage: false
    };
  },
  computed: {
    ...mapState("chat", ["activeConversation"]),
    ...mapGetters('presence', ['usersPresence']),
    filteredUsersPresence() {
      return this.usersPresence
          .filter(list => list.status !== 'offline')
          .map(list => ({...list}))
    }
  },
  methods: {
    ...mapActions('presence', ['setUsersPresence']),
    ...mapMutations("chat", ["SET_CHAT_ROOMS", "SET_SHOW_CHAT_CONTAINER"]),

    getUserClasses(user) {
      return [
        'd-flex',
        'align-items-center',
        'is-show',
        'user-online',
        `user-online-${user.id}`,
        this.getStatusClass(user.status)
      ]
    },
    getStatusClass(status) {
      const statusClasses = {
        'online': 'is-active',
        'visit': 'is-visit',
        'training': 'is-training',
        'lunch': 'is-lunch',
        'dnd': 'is-dnd',
        'call': 'is-call',
        'video-call': 'is-video-call'
      };

      return statusClasses[status] || 'is-inactive';
    },
    toggleUsers() {
      this.isUsersExpanded = !this.isUsersExpanded

      if (!this.isUsersExpanded) {
        this.showSearchForm = false
      }
    },
    toggleSearchForm() {
      this.showSearchForm = !this.showSearchForm

      if (this.showSearchForm) {
        const listContainer = document.getElementById('users-list-container').clientWidth
        const searchMenu = document.getElementById('search-user-menu')

        searchMenu.style.setProperty('--changeWidth', listContainer + "px")
      }
    },
    searchUsersByName(value) {
      if (this.searchTimeout) {
        clearTimeout(this.searchTimeout);
      }

      this.searchValue = value;

      if (this.searchValue && this.searchValue.length > 0) {
        this.isLoading = true;
        this.searchTimeout = setTimeout(async () => {
          try {
            const response = await searchUsers({ q: this.searchValue });

            if (response.status === 200) {
              this.searchResults = response.data;
              this.showNotFoundMessage = this.searchResults.length === 0;
            }
          } catch (error) {
            console.error("Error searching users:", error);
          } finally {
            this.isLoading = false;
          }
        }, 300); // Adjust the debounce delay as needed (e.g., 300 milliseconds)
      } else {
        this.searchResults = [];
        this.showNotFoundMessage = false;
      }
    },
    async openChatConversation(user_id) {
      try {
        this.toggleUsers();

        const response = await openChatRoom(user_id);
        const roomId = response?.data?.room_id;

        if (roomId !== this.activeConversation) {
          const rooms = await getFloatingChatRooms('1');

          this.SET_SHOW_CHAT_CONTAINER(true);
          this.SET_CHAT_ROOMS(rooms.data);
        } else {
          isFloating({ room_id: this.activeConversation, is_floating: false });
        }
      } catch (error) {
        console.error('Error opening chat conversation:', error);
      }
    }
  },
  mounted() {
    this.setUsersPresence(this.userLists)
  }
}
</script>
